import * as CONST from 'Reducers/Campaigns/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'
import { STATUS_CAMPAIGN_ENUM_ACTIVE } from './../../shared/constants'
import * as MISSION_CONST from './../Mission/const'
import { normalizeGraphQLConnection } from '../../shared/graphql/utils'

const initState = {
  campaignById: {},
  campaignsList: [],
  activeCampaignsList: [],
  cityPlanById: {},
  cityPlansByCampaignId: [],
  cityPlansByCampaignIdForFlyerCodesForm: [],
  cityPlansByCampaignIdSortBy: {
    columnName: null,
    reverse: false,
  },
  paymentsByCampaignId: [],
  clientViewCampaigns: [],
  clientViewStatusFilter: STATUS_CAMPAIGN_ENUM_ACTIVE,
  listFilters: {
    statusFilter: STATUS_CAMPAIGN_ENUM_ACTIVE,
    clientFilter: null,
    countryFilter: null,
    dateFrom: null,
    dateTo: null,
  },
  // A hashmap of campaigns id => campaign data. Currently used for metrics but
  // can be used for anything
  campaigns: {},
}

export function campaigns(state = initState, action) {
  switch (action.type) {
    case CONST.GET_CITY_PLAN_BY_ID_SUCCESS:
      return {
        ...state,
        cityPlanById: action.payload.cityPlanById,
      }

    case CONST.GET_CITY_PLANS_BY_CAMPAIGN_ID_FOR_FLYER_CODES_FORM_SUCCESS:
      return {
        ...state,
        cityPlansByCampaignIdForFlyerCodesForm:
          action.payload.cityPlansByCampaignIdForFlyerCodesForm,
      }

    case CONST.SET_CITY_PLANS_BY_CAMPAIGN_ID_SORT_BY:
      return {
        ...state,
        cityPlansByCampaignIdSortBy: action.sortBy,
      }

    case CONST.GET_PAYMENTS_BY_CAMPAIGN_ID_SUCCESS:
      return {
        ...state,
        paymentsByCampaignId: action.paymentsByCampaignId,
      }

    case CONST.EDIT_PAYMENTS_BY_CAMPAIGN_ID_SUCCESS:
      var newState = state
      action.paymentsByCampaignId.forEach(payment => {
        // old payment
        var oldPaymentIndex = newState.paymentsByCampaignId.findIndex(p => {
          return (
            p.startDate == payment.startDate &&
            p.cityPlanId == payment.cityPlanId
          )
        })
        if (oldPaymentIndex != -1) {
          var copy = newState.paymentsByCampaignId.slice(0)
          copy.splice(oldPaymentIndex, 1, payment)
          newState = {
            ...newState,
            paymentsByCampaignId: copy,
          }
        }
      })
      return newState

    case CONST.CLEAR_CITY_PLAN_BY_ID:
      return {
        ...state,
        cityPlanById: initState.cityPlanById,
      }

    case CONST.GET_CAMPAIGNS_BY_CLIENT_ID_SUCCESS:
      return {
        ...state,
        clientViewCampaigns: action.payload.clientViewCampaigns,
      }

    case CONST.RESET_CAMPAIGNS_BY_CLIENT_ID:
      return {
        ...state,
        clientViewCampaigns: [],
      }

    case CONST.CLEAR_CAMPAIGN_BY_ID:
      return {
        ...state,
        campaignById: initState.campaignById,
      }

    case CONST.GET_CAMPAIGNS_ERROR:
      return {
        ...state,
      }

    case CONST.GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaignsList: action.payload.campaigns,
      }
    case CONST.GET_ACTIVE_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        activeCampaignsList: normalizeGraphQLConnection(
          action.result.data.campaigns,
        ),
      }

    case CONST.SET_CAMPAIGNS_CLIENT_FILTER:
      return {
        ...state,
        listFilters: {
          ...state.listFilters,
          clientFilter: action.clientFilter,
        },
      }

    case CONST.SET_CAMPAIGNS_COUNTRY_FILTER:
      return {
        ...state,
        listFilters: {
          ...state.listFilters,
          countryFilter: action.countryFilter,
        },
      }

    case CONST.SET_CAMPAIGNS_STATUS_FILTER:
      return {
        ...state,
        listFilters: {
          ...state.listFilters,
          statusFilter: action.statusFilter,
        },
      }

    case CONST.SET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER:
      return {
        ...state,
        clientViewStatusFilter: action.statusFilter,
      }

    case CONST.RESET_CLIENT_VIEW_CAMPAIGNS_STATUS_FILTER:
      return {
        ...state,
        clientViewStatusFilter: STATUS_CAMPAIGN_ENUM_ACTIVE,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        clientViewStatusFilter: initState.clientViewStatusFilter,
        listFilters: initState.listFilters,
      }
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS: {
      var campaignData = action.result.data.campaign
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          [campaignData.id]: Object.assign(
            {},
            // Preserve any existing data
            state.campaigns[campaignData.id],
            {
              ...campaignData,
              id: campaignData.id,
              name: campaignData.name,
              countryName: campaignData.countryName,
              country: campaignData.Country,
              clientId: campaignData.client.id,
              //missions: campaignData.missions.edges.map(({ node }) => node.id),
              ...(() => {
                var cityPlans = action.result.data.campaign.cityPlans.nodes
                var subObject = {
                  missionIds: [],
                  cityPlanIds: [],
                }
                cityPlans.forEach(cityPlan => {
                  subObject.cityPlanIds.push(cityPlan.id)
                  cityPlan.missions.edges.forEach(({ node }) =>
                    subObject.missionIds.push(node.id),
                  )
                })
                return subObject
              })(),
              metricIds: campaignData.metrics.nodes.map(node => node.id),
            },
          ),
        },
      }
    }
    case CAMPAIGN_CONST.GET_CAMPAIGN_BY_ID_SUCCESS: {
      const { campaign } = action.result.data
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          [campaign.id]: {
            ...campaign,
            ...state.campaigns[campaign.id],
          },
        },
      }
    }
    case MISSION_CONST.DELETE_MISSIONS:
      var campaigns = {
        ...state.campaigns,
      }

      action.payload.missions.forEach(({ id }) => {
        Object.keys(campaigns).forEach(campaignId => {
          var cObj = (campaigns[campaignId] = Object.assign(
            {},
            campaigns[campaignId],
          ))

          var index = cObj.missionIds.findIndex(lId => id == lId)
          if (index !== -1) {
            cObj.missionIds = cObj.missionIds.slice(0)
            cObj.missionIds.splice(index, 1)
          }
        })
      })

      return {
        ...state,
        campaigns,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Campaigns/reducer.js